import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const viewButton: SxStyle = {
  color: (p) => p.palette.primary[500],
  background: (p) => p.palette.primary[50],
  borderColor: (p) => p.palette.primary[500],
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightLight,
};

export const arrowsClose: SxStyle = {
  color: (p) => p.palette.grey[500],
  '&:hover': {
    color: (p) => p.palette.primary[500],
  },
};

// TODO change this with an outline Icon
export const arrowsAccordion: SxStyle = {
  borderWidth: 1,
  borderStyle: 'solid',
  borderRadius: (p) => p.spacing(0.7),
  padding: (p) => p.spacing(0.5),
  width: (p) => p.spacing(3),
  height: (p) => p.spacing(3),
};

export const iconAccordion: SxStyle = {
  padding: (p) => p.spacing(0),
  color: (p) => p.palette.grey[500],
  borderColor: (p) => p.palette.grey[300],

  '&:hover': {
    backgroundColor: (p) => p.palette.common.white,
  },

  '&:disabled': {
    color: (p) => p.palette.grey[200],
    borderColor: (p) => p.palette.grey[200],
  },
};

export const header: SxStyle = {
  backgroundColor: (p) => `${p.palette.common.white} !important`,
  borderBottomColor: (p) => `${p.palette.grey[300]} !important`,
};

export const actions: SxStyle = {
  flexDirection: 'row-reverse',
  placeContent: 'end',
  borderTopColor: (p) => `${p.palette.grey[300]} !important`,
};
